import { render, staticRenderFns } from "./BrowseLayout.vue?vue&type=template&id=1f08f3cf&scoped=true&"
import script from "./BrowseLayout.vue?vue&type=script&lang=js&"
export * from "./BrowseLayout.vue?vue&type=script&lang=js&"
import style0 from "./BrowseLayout.vue?vue&type=style&index=0&id=1f08f3cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f08f3cf",
  null
  
)

export default component.exports